module.exports = __webpack_public_path__ + "img/gear.933396c0.svg";